/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterN = createReactComponent("letter-n", "IconLetterN", [
  ["path", { d: "M7 20v-16l10 16v-16", key: "svg-0" }]
]);

export { IconLetterN as default };
//# sourceMappingURL=IconLetterN.js.map
